module.exports = __webpack_public_path__ + "static/modular-components-1a5539509abe2b7f2f2d2ed12160e731.png";